export const validateFiles = (files, sizeLimit, typeLimit) => {
  const filteredFiles = files
    .filter((file) => file.size <= sizeLimit)
    .filter((file) => (typeLimit ? typeLimit.includes(file.type) : file));

  return filteredFiles;
};
